<template>
  <div class="campanha">
    <a class="b-col-sm-1">
      <i class="fa fa-fw fa-check-circle text-success text-3x m-t-xs" title="Enviado"></i>
    </a>
    <div class="b-col-sm-5">
      <div>
        <campanha-titulo />
        <div class="m-t-sm">
          Manual <span>(Segmentada)</span>
        </div>
      </div>
      <div class="text-ellipsis m-t-sm">
        <span><strong>Enviado.</strong> 1 dia atrás, domingo, 02 de maio de 2021</span>
      </div>
    </div>
    <div class="b-col-sm-3 no-padder m-t hoverable">
      <div class="b-col-md-3">
        <div class="">100</div>
        <div class="text-muted inline m-t-xs">inscritos</div>
        <hr class="clearfix hidden-sm hidden-md hidden-lg m-t-xs m-b-xs">
      </div>
      <div class="b-col-md-3">
        <div class="hide-on-hover">48%</div>
        <div class="show-on-hover">1.298</div>
        <div class="text-muted inline m-t-xs">abertos</div>
        <hr class="clearfix hidden-sm hidden-md hidden-lg m-t-xs m-b-xs">
      </div>
      <div class="b-col-md-3 hoverable">
        <div class="hide-on-hover">26%</div>
        <div class="show-on-hover">26</div>
        <div class="text-muted m-t-xs">cliques</div>
        <hr class="clearfix hidden-sm hidden-md hidden-lg m-t-xs m-b-xs">
      </div>
    </div>
    <div class="b-col-sm-3">
      <div class="u-btn-group-container m-t text-right">
        <u-btn label="Visualizar Relatório" no-caps color="grey-3" text-color="blue-grey-8" />
        <!--              <u-btn icon="caret-down" icon-type="fa" no-caps color="dark" class="btn-right" />-->
        <u-btn-dropdown
            color="grey-3" text-color="blue-grey-8"
            :popover-offset="[0, 4]"
        >
          <u-list class="list-default" link>
            <u-btn class="u-btn-list" v-close-overlay align="left" label="Pré-visualizar" flat no-caps />
            <u-btn class="u-btn-list" v-close-overlay align="left" label="Duplicar" flat no-caps />
          </u-list>
        </u-btn-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import CampanhaTitulo from "@/components/marketing/components/CampanhaTitulo";
import {UBtnDropdown, UList, CloseOverlay} from 'uloc-vue'
export default {
  name: "Campanha",
  components: {CampanhaTitulo, UBtnDropdown, UList},
  directives: {CloseOverlay}
}
</script>
